
// export const BaseUrl = "http://34.46.193.200:4001";




var BaseUrl=process.env.REACT_APP_INR_API_URL
var SocketUrl=process.env.REACT_APP_SOCKET_IO_URL


console.log(BaseUrl,"BaseUrl")
console.log(SocketUrl,"SocketUrl")













// 



const validateResponse = (isOk, status, onSuccess, onFails, data) => {

    if (isOk) {
        onSuccess(data)
        return
    }
    else if (status === 401) {
        // store.dispatch(remove_token()); // ✅ Dispatch action outside React
        // localStorage.removeItem("exchangeState");
        // window.location.href = "/"
        // return
    }
    else if (String(status).charAt(0) == "3") {
        window.location.href = "/block"
        return
    }
    else if (String(status).charAt(0) == "4") {
        onFails(data)
        return
    }
    else if (String(status).charAt(0) == "5") {
        console.log("k")
        onFails({
            message : "Server failed !"
        })
        return
    }
    else{
        onFails({
            message : "Something went wrong!"
        })
        return
    }

    // todi - maintenance
}







export const Post = async (
    url,
    body,
    onSuccess,
    onFails,
    onFinally,
    isToken,
    isFormdata
) => {
    const myHeaders = new Headers();

    const token = localStorage.getItem("token")
    if (isToken) {
        myHeaders.append("Authorization", `Bearer ${token}`);
    }
    if (!isFormdata) {
        myHeaders.append("Content-Type", "application/json");
    }

    console.log(myHeaders)

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body,
        redirect: 'follow'
    };

    try {
        const response = await fetch(`${BaseUrl}${url}`, requestOptions);
        const data = await response.json();

        validateResponse(response.ok, response.status, onSuccess, onFails, data)
        onFinally();
    } catch (error) {
        console.log(error,"hh")
        onFails({
            message : "Server is Down"
        })
        onFinally();
        console.log(error);
    }
}



export const Patch = async (
    url,
    body,
    onSuccess,
    onFails,
    onFinally,
    isToken,
    isFormdata
)=> {
    const myHeaders = new Headers();
    const token = localStorage.getItem("token")
    if (isToken) {
        myHeaders.append("Authorization", `Bearer ${token}`);
    }
    if (!isFormdata) {
        myHeaders.append("Content-Type", "application/json");
    }

    const requestOptions= {
        method: 'PATCH',
        headers: myHeaders,
        body,
        redirect: 'follow'
    };

    try {
        const response = await fetch(`${BaseUrl}${url}`, requestOptions);
        const data = await response.json();
        validateResponse(response.ok, response.status, onSuccess, onFails, data)
        onFinally();
    } catch (error) {
        onFails({
            message : "Server is Down"
        })
        onFinally();
        console.log(error);
    }
}

export const Put = async (
    url,
    body,
    onSuccess,
    onFails,
    onFinally,
    isToken,
    isFormdata
)=> {
    const myHeaders = new Headers();

    const token = localStorage.getItem("token")
    if (isToken) {
        myHeaders.append("Authorization", `Bearer ${token}`);
    }
    if (!isFormdata) {
        myHeaders.append("Content-Type", "application/json");
    }

    const requestOptions= {
        method: 'PUT',
        headers: myHeaders,
        body,
        redirect: 'follow'
    };

    try {
        const response = await fetch(`${BaseUrl}${url}`, requestOptions);
        const data = await response.json();
        validateResponse(response.ok, response.status, onSuccess, onFails, data)
        onFinally();
    } catch (error) {
        onFails({
            message : "Server is Down"
        })
        onFinally();
        console.log(error);
    }
}

export const Delete = async (
    url,
    body,
    onSuccess,
    onFails,
    onFinally,
    isToken,
    isFormdata
)=> {
    const myHeaders = new Headers();

    const token = localStorage.getItem("token")
    if (isToken) {
        myHeaders.append("Authorization", `Bearer ${token}`);
    }
    if (!isFormdata) {
        myHeaders.append("Content-Type", "application/json");
    }

    const requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body,
        redirect: 'follow'
    };

    try {
        const response = await fetch(`${BaseUrl}${url}`, requestOptions);
        const data = await response.json();
        validateResponse(response.ok, response.status, onSuccess, onFails, data)
        onFinally();
    } catch (error) {
        onFails({
            message : "Server is Down"
        })
        onFinally();
        console.log(error);
    }
}

export const Get = async (
    url,
    onSuccess,
    onFails,
    onFinally,
    isToken
)=> {
    const myHeaders = new Headers();


    console.log(BaseUrl,"ehckinh")

    const token = localStorage.getItem("token")
    if (isToken) {
        myHeaders.append("Authorization", `Bearer ${token}`);
    }

    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    try {
        const response = await fetch(`${BaseUrl}${url}`, requestOptions);
        const data = await response.json();
        validateResponse(response.ok, response.status, onSuccess, onFails, data)
        onFinally();
    } catch (error) {
        onFails({
            message : "Server is Down"
        })
        onFinally();
        console.log(error);
    }
}


export {SocketUrl,BaseUrl}
